import { InBodyHistoryPage, InBodyInterviewPage, InBodyOverviewFilterPage } from '@icoach/inbody/';
import { MeasureLeaderboardPage } from '@icoach/measureLeaderboard/';
import { CLUB_INBODY_ROUTER, MEASURE_HEADERBOARD_ROUTER } from '@icoach/router/routerPath';
import EmployeeInBodyInterviewPage from '@icoach/inbody/employeeInbodyInterview/EmployeeInBodyInterviewPage';

const inbodyRouter = [
	{
		description: '量身管理',
		frontKey: 'C8X01'
	},
	{
		description: '教練量身資訊',
		static: true,
		path: CLUB_INBODY_ROUTER.EMPLOYEE_INTERVIEW_PAGE,
		as: EmployeeInBodyInterviewPage,
		frontKey: 'C8X06'
	},
	{
		description: '會員的面談&量身&比較',
		static: true,
		path: CLUB_INBODY_ROUTER.INTERVIEW_PAGE,
		as: InBodyInterviewPage,
		frontKey: 'C8X02'
	},
	{
		description: '量身歷史紀錄清單',
		static: true,
		path: CLUB_INBODY_ROUTER.HISTORY_PAGE,
		href: CLUB_INBODY_ROUTER.HISTORY,
		as: InBodyHistoryPage,
		frontKey: 'C8X03'
	},
	{
		description: '快速名單',
		exact: true,
		path: CLUB_INBODY_ROUTER.OVERVIEW_FILTER_PAGE,
		href: CLUB_INBODY_ROUTER.GET_OVERVIEW_FILTER_PATH(1),
		as: InBodyOverviewFilterPage,
		frontKey: 'C8X04'
	},
	{
		description: '全店排行榜',
		static: true,
		path: MEASURE_HEADERBOARD_ROUTER,
		href: MEASURE_HEADERBOARD_ROUTER,
		as: MeasureLeaderboardPage,
		frontKey: 'C8X05'
	}
];

export default inbodyRouter;
